import { Messages } from '~src/codegen/Localize';

import { IConnectedApplicationType } from '../serverApi/types/ConnectedApplicationType';
import { ConnectedApplicationType, IConnectedApplicationInfo } from './ConnectedApplicationInfo';

// maps from the wire "Type" to the internal "Info" representation
// this would be straighforward except we are mapping "clientId" to "id"
// because there is code that likes "id"
export module ConnectedApplicationInfoMapper {

  export function map(
    rows: IConnectedApplicationType[]
  ): IConnectedApplicationInfo[] {
    return rows.map((m: IConnectedApplicationType) => {
      let domainSafelist = m.domainSafelist?.replace(/\s/g, '\n');

      return {
        contentType: 'connectedApplication',
        createdAt: m.createdAt,
        domainSafelist: domainSafelist,
        enabled: m.enabled,
        id: (m.clientId === undefined) ? m.id : m.clientId,
        name: m.name,
        projectId: m.projectId,
        unrestrictedEmbedding: m.unrestrictedEmbedding,
        domainSafelistForDisplay: convertDomainSafelistToDisplay(domainSafelist, m.unrestrictedEmbedding),
        jwksUri: m.jwksUri,
        issuerUrl: m.issuerUrl,
      };
    });
  }

  export function mapToExternalAuthorizationServerInfoType(
    rows: IConnectedApplicationType[]
  ): IConnectedApplicationInfo[] {
    return rows.map((m: IConnectedApplicationType) => {
      return {
        contentType: 'connectedApplication',
        createdAt: m.createdAt,
        enabled: m.enabled,
        id: (m.clientId === undefined) ? m.id : m.clientId,
        name: Messages.connectedApplicationsEasName(),
        jwksUri: m.jwksUri,
        issuerUrl: m.issuerUrl,
        connectedApplicationType: ConnectedApplicationType.EAS,
        trustType: Messages.connectedApplicationsOAuth(),
        authorizationServerType: Messages.connectedApplicationsAuthorizationServerExternal()
      };
    });
  }

  export function mapToDirectTrustInfoType(
    rows: IConnectedApplicationType[]
  ): IConnectedApplicationInfo[] {
    return rows.map((m: IConnectedApplicationType) => {
      let domainSafelist = m.domainSafelist?.replace(/\s/g, '\n');

      return {
        contentType: 'connectedApplication',
        createdAt: m.createdAt,
        domainSafelist: domainSafelist,
        enabled: m.enabled,
        id: m.clientId,
        name: m.name,
        projectId: m.projectId,
        unrestrictedEmbedding: m.unrestrictedEmbedding,
        domainSafelistForDisplay: convertDomainSafelistToDisplay(domainSafelist, m.unrestrictedEmbedding),
        connectedApplicationType: ConnectedApplicationType.DIRECT_TRUST,
        trustType: Messages.connectedApplicationsDirect(),
        authorizationServerType: Messages.connectedApplicationsAuthorizationServerTableau()
      };
    });
  }

  export function convertDomainSafelistToDisplay(domainSafelist: string, unrestrictedEmbedding: boolean) {
    if (unrestrictedEmbedding) {
      // setting domain to undefined is equivalent to "All Domains"
      return undefined;
    }
    return (domainSafelist === undefined) ?
      '' : // setting domain to empty is equivalent to "None Domains"
      domainSafelist;
  }
}